/**
 * Mobile homepage layout tokens — Figma Dev Ready (390px frame, 350px content).
 * Tabs: node 2819:182299 (108×76). Form card: node 2819:182310 (350×504).
 * @see https://www.figma.com/design/DycZKMsOKMIW3ETKgZudne/Yovotrip?node-id=2819-182299
 */

/** 20px side gutter @ 390px → 350px content width */
export const MOBILE_CONTENT_GUTTER = 'clamp(16px, 5.13vw, 20px)';

export const MOBILE_HOMEPAGE_LAYOUT = {
  contentGutter: MOBILE_CONTENT_GUTTER,
  formCardWidth: `calc(100% - (2 * ${MOBILE_CONTENT_GUTTER}))`,

  /* Service tabs — 108×76, 16px radius, 16×12 padding, 4px icon/text gap */
  tabHeight: 'clamp(68px, 19.49vw, 76px)',
  tabGap: 'clamp(8px, 3.33vw, 13px)',
  tabRadius: 'clamp(14px, 4.1vw, 16px)',
  tabPaddingY: 'clamp(10px, 3.08vw, 12px)',
  tabPaddingX: 'clamp(12px, 4.1vw, 16px)',
  tabContentGap: 'clamp(3px, 1.03vw, 4px)',
  tabIconSize: 'clamp(24px, 7.18vw, 28px)',
  tabFontSize: 'clamp(12px, 3.59vw, 14px)',

  /* Grey search card — 350×504 flight, 16px radius, 12×16 padding */
  formCardRadius: 'clamp(14px, 4.1vw, 16px)',
  formCardPaddingX: 'clamp(10px, 3.08vw, 12px)',
  formCardPaddingY: 'clamp(14px, 4.1vw, 16px)',
  /** Gap between trip-type row and inner white filter box (~50% tighter vs 16px Figma). */
  formCardSectionGap: 'clamp(7px, 2.05vw, 8px)',

  /* Inner white filter box */
  innerBoxRadius: 'clamp(20px, 6.15vw, 24px)',
  innerBoxPadding: 'clamp(14px, 4.1vw, 16px)',
  /** Top pad of inner filter box — slightly less than sides so From/To sit closer to card top. */
  innerBoxPaddingTop: 'clamp(10px, 2.8vw, 12px)',
  /** Bottom pad of inner filter box — ~50% of innerBoxPadding top/sides. */
  innerBoxPaddingBottom: 'clamp(7px, 2.05vw, 8px)',

  /*
   * Red hero depth: tab bottom → inner From/To row (~94px @ 390px).
   *   clearance 16 + card pt 16 + trip row 30 + section gap 16 + inner pad 16
   * Must stay paired: tabs-wrap padding-bottom = |#yovo-homepage-main-card mt|
   */
  headerRedTail: 'clamp(72px, 24vw, 96px)',
  formCardPullUp: 'calc(-1 * clamp(72px, 24vw, 96px))',
  formCardTopClearance: 'clamp(12px, 3.5vw, 16px)',
  formCardGapBelowTabs: 'clamp(12px, 3.5vw, 16px)',

  /** @deprecated use headerRedTail — kept for any legacy references */
  formOverlap: 'clamp(72px, 24vw, 96px)',
};
